import { render } from "./actionWrite.vue?vue&type=template&id=16973ce8&scoped=true&ts=true"
import script from "./actionWrite.vue?vue&type=script&lang=ts&config=true"
export * from "./actionWrite.vue?vue&type=script&lang=ts&config=true"

import "./actionWrite.vue?vue&type=style&index=0&id=16973ce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16973ce8"]])

export default __exports__